import { useDesyncAccount } from '../queries';
import type { StatusType } from '../types';

const useDexcomDesync = (onFinished: (result: { messageText: string; status: StatusType }) => void) => {
  const { isPending: isDesyncing, mutate: desyncAccount } = useDesyncAccount();

  const desyncDexcom = () => {
    desyncAccount(undefined, {
      onError() {
        onFinished({ messageText: 'Dexcom account unlink failed', status: 'error' });
      },
      onSuccess() {
        onFinished({ messageText: 'Dexcom account unlinked', status: 'success' });
      },
    });
  };

  return { desyncDexcom, isDesyncing };
};

export default useDexcomDesync;
